import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import PersonIcon from "@mui/icons-material/Person";
import { colors } from "./colors";


export const aiIndicationIcons = {
  Human: (
    <PersonIcon
      sx={{ margin: "0px !important", color: "#1976D2" }}
    />
  ),
  AI: <AutoFixHighIcon sx={{ color: "#1976D2" }} />,
  Combined: (
    <>
      <PersonIcon
        sx={{ margin: "0px !important", color: "#1976D2" }}
      />
      <AutoFixHighIcon sx={{ color: "#1976D2" }} />
    </>
  ),
};

export const aiIndicationIconsAvatar = {
    Human: (
      <PersonIcon
        sx={{  width: "16px", height: "16px", margin: "0px !important", color: `${"#1976D2"}` }}
      />
    ),
    AI: <AutoFixHighIcon sx={{  width: "16px",  height: "16px",  color: `${"#1976D2"}` }} />,
    Combined: (
      <>
        <PersonIcon
          sx={{  width: "16px", height: "16px", margin: "0px !important",  color: `${"#1976D2"}` }}
        />
        <AutoFixHighIcon sx={{  width: "16px", height: "16px",  color: `${"#1976D2"}` }} />
      </>
    ),
  };
